import React from "react";
/** Components Import */
import Section from "../../Components/Section";
import Card from "../../Components/Card_wrap";
import AuthGroupButton from "../../Components/Button_Auth_Group";
import BasicButton from "../../Components/Button_Basic";
import Dialog from "../../Services/Common/Dialog";
import DatePicker from "../../Components/Datepicker_Basic";
import FormGroup from "../../Components/Form_Group";
import CardH3 from "../../Components/Card_H3";
import InputBasic from "../../Components/Input_Basic";
import GridModal from "../../Components/Modal_Grid";
import AgDatePicker from "../../Components/agGrid/ag-DatePicker";
import Input from "../../Components/Input_Basic";
import Radio from "../../Components/Radio_Basic";
/** Ag-grid Import */
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import GridFunctions from "../../Services/agGrid/ag-Grid-functions";
import Commons from "../../Services/Common/Common";
function ST10020(props) {
  React.useEffect(() => {
    document.title = "재고조사업로드";

    const element = document.getElementById("topbar");
    element.innerHTML =
      "<h1>" +
      "<span class='bullet'>" +
      "</span>" +
      "<strong class='depth-1'>" +
      "재고관리" +
      "	</strong>" +
      "<span class='divider' >" +
      "</span>" +
      "<strong'>재고조사업로드</strong>" +
      "</h1>";
  }, []);
  const gridRef = React.useRef();
  const [selectedRadio, setSelectedRadio] = React.useState("0");

  const columnDefs = [
    //사업장
    {
      field: "plantNm",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_PlantCd" && f.lanType === "COL"
            )[0].lanName
          : "",
      editable: false,
      cellStyle: { textAlign: "center" },
      minWidth: 90,
      cellRenderer: Commons.CustomPlantRenderer,
    },

    //품목명
    {
      field: "itemNm",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_ItemNm" && f.lanType === "COL"
            )[0].lanName
          : "",
      minWidth: 300,
      editable: false,
      rowGroup: selectedRadio === "1" ? true : false,
      hide: selectedRadio === "1" ? true : false,
    },
    //규격
    {
      field: "itemStd",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_ItemStd1" && f.lanType === "COL"
            )[0].lanName
          : "",
      editable: false,
      cellStyle: { textAlign: "center" },
      minWidth: 120,
    },
    //창고
    {
      field: "whNm",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_WhNm" && f.lanType === "COL"
            )[0].lanName
          : "",
      editable: false,
      cellStyle: { textAlign: "center" },
      minWidth: 130,
      cellRenderer: Commons.CustomWhCdRenderer,
    },
    //실사창고
    {
      field: "checkWhCd",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_CheckWh" && f.lanType === "COL"
            )[0].lanName
          : "",
      editable: true,
      cellEditor: "agSelectCellEditor",
      cellEditorParams: {
        values: props.inputs.comboList,
        default: props.inputs.comboValue,
      },
      valueParser: (params) => {
        return props.inputs.comboValue;
      },
      valueFormatter: (params) => {
        if (params.value == undefined) {
          return null;
        } else {
          return params.value.name;
        }
      },
      cellStyle: { textAlign: "center" },
      minWidth: 130,
      // cellRenderer: Commons.CustomWhCdRenderer,

      cellRenderer: (value) => {
        if (
          value == undefined ||
          value == "undefined" ||
          value == null ||
          !value
        ) {
          //value가 없을때
        } else {
          if (!value.data) {
            //value.data가 없을때
          } else {
            if (value.data.checkWhCd.name != undefined) {
              return (
                <div
                  style={{
                    color:
                      value.data.checkWhCd.name ===
                        "[부산][입고][B][IN-warehouse]" ||
                      value.data.checkWhCd.name ===
                        "[부산][B][생산][Production]"
                        ? "orange"
                        : value.data.checkWhCd.name ===
                            "[서울][입고][S][IN-warehouse]" ||
                          value.data.checkWhCd.name ===
                            "[서울][S][생산][Production]"
                        ? "green"
                        : value.data.checkWhCd.name ===
                            "[베트남][입고][V][IN-warehouse]" ||
                          value.data.checkWhCd.name ===
                            "[베트남][V][생산][Production]"
                        ? "blue"
                        : value.data.checkWhCd.name ===
                            "[중국][입고][C][入庫倉庫]" ||
                          value.data.checkWhCd.name === "[중국][생산]生產倉庫"
                        ? "red"
                        : "",
                  }}
                >
                  {value.data.checkWhCd.name}
                </div>
              );
            } else {
              return (
                <div
                  style={{
                    color:
                      value.data.checkWhCd ===
                        "[부산][입고][B][IN-warehouse]" ||
                      value.data.checkWhCd === "[부산][B][생산][Production]"
                        ? "orange"
                        : value.data.checkWhCd ===
                            "[서울][입고][S][IN-warehouse]" ||
                          value.data.checkWhCd === "[서울][S][생산][Production]"
                        ? "green"
                        : value.data.checkWhCd ===
                            "[베트남][입고][V][IN-warehouse]" ||
                          value.data.checkWhCd ===
                            "[베트남][V][생산][Production]"
                        ? "blue"
                        : value.data.checkWhCd ===
                            "[중국][입고][C][入庫倉庫]" ||
                          value.data.checkWhCd === "[중국][생산]生產倉庫"
                        ? "red"
                        : "",
                  }}
                >
                  {value.data.checkWhCd}
                </div>
              );
            }
          }
        }
      },
    },

    //발주수량
    {
      field: "stockAddQty",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_PoItemQty" && f.lanType === "COL"
            )[0].lanName
          : "",
      editable: false,
      cellStyle: { textAlign: "right" },
      aggFunc: "sum",
      minWidth: 100,
      cellRenderer: Commons.CustomNumberRenderer,
    },
    //재고수량(BOM)
    {
      field: "stockQty",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_Calculate_Qty" && f.lanType === "COL"
            )[0].lanName
          : "",
      cellStyle: { textAlign: "right" },
      cellRenderer: Commons.CustomNumberRenderer,
      aggFunc: "sum",
      minWidth: 140,
      editable: false,
    },
    //실사수량
    {
      field: "checkQty",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_CheckQty" && f.lanType === "COL"
            )[0].lanName
          : "",
      editable: true,
      cellRenderer: Commons.CustomNumberRenderer,
      cellStyle: { textAlign: "right" },
      aggFunc: "sum",
      minWidth: 140,
    },
    // //차이수량
    // {
    //   field: "needQty",
    //   headerName:
    //     props.lanData.length > 0
    //       ? props.lanData.filter(
    //           (f) => f.lanId === "Col_NeedQty" && f.lanType === "COL"
    //         )[0].lanName
    //       : "",
    //   editable: false,
    //   cellStyle: { textAlign: "right" },
    //   aggFunc: "sum",
    //   minWidth: 140,
    // },
    //단위
    {
      field: "itemUnit",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_ItemUnit" && f.lanType === "COL"
            )[0].lanName
          : "",
      editable: false,
      minWidth: 100,
    }, //품목단가
    {
      field: "itemStdAmt",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_SoItemCost" && f.lanType === "COL"
            )[0].lanName
          : "",
      cellStyle: { textAlign: "right" },
      valueFormatter: (params) => {
        var formatted = params.value
          ? params.value
              .toString()
              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
          : "";
        return formatted;
      },
      aggFunc: "sum",
      editable: false,
      minWidth: 100,
    },
    //금액
    {
      field: "soItemAmt",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_SoItemAmt" && f.lanType === "COL"
            )[0].lanName
          : "",
      cellStyle: { textAlign: "right" },
      valueFormatter: (params) => {
        var formatted = params.value
          ? params.value
              .toString()
              .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",")
          : "";
        return formatted;
      },
      aggFunc: "sum",
      editable: false,
      minWidth: 100,
    },

    //거래처명
    {
      field: "custNm",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_CustNm" && f.lanType === "COL"
            )[0].lanName
          : "",
      editable: false,
      minWidth: 150,
    },

    //대분류
    {
      field: "lCatego",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_Lcategory" && f.lanType === "COL"
            )[0].lanName
          : "",
      minWidth: 110,
    },
    //중분류
    {
      field: "mCatego",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_Mcategory" && f.lanType === "COL"
            )[0].lanName
          : "",
      minWidth: 110,
    },
    //소분류
    {
      field: "sCatego",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_Scategory" && f.lanType === "COL"
            )[0].lanName
          : "",
      minWidth: 110,
    },
    //품목그룹
    {
      field: "itemGroup",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_ItemGroupNm" && f.lanType === "COL"
            )[0].lanName
          : "",
      editable: false,
      minWidth: 110,
    },
    //품목카테고리
    {
      field: "itemCatego",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_ItemCategory" && f.lanType === "COL"
            )[0].lanName
          : "",
      editable: false,
      minWidth: 130,
    },
    //프로젝트명
    {
      field: "projectNm",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_ProjectNm" && f.lanType === "COL"
            )[0].lanName
          : "",
      editable: false,
      minWidth: 150,
    },
    //담당자
    {
      field: "personCharg",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_PersonCharg" && f.lanType === "COL"
            )[0].lanName
          : "",
      editable: false,
      minWidth: 110,
    },
    //품목코드
    {
      field: "itemCd",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_ItemCd" && f.lanType === "COL"
            )[0].lanName
          : "",
      editable: false,
      minWidth: 100,
    },
    //LotNo
    {
      field: "lotNo",
      headerName:
        props.lanData.length > 0
          ? props.lanData.filter(
              (f) => f.lanId === "Col_LotNo" && f.lanType === "COL"
            )[0].lanName
          : "",
      editable: false,
      minWidth: 120,
    },
  ];
  const onCellClicked = (e) => {
    const selected = e.data;
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-evenly",
        alignItems: "center",
      }}
    >
      <div style={{ width: "100%" }}>
        <Section />
        <Card
          wrapStyle={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            품목코드/명
            <Input
              type={"text"}
              value={props.orderNumber}
              onChange={(e) => {
                props.setParamsItemCd(e.target.value);
              }}
              onClick={() => {}}
              onKeyDown={(e) => {
                if (e.key == "Enter") {
                  props.SearchLogic();
                }
              }}
            />
            <Radio
              style={{
                display: "flex",
                alignItems: "center",
              }}
              items={[
                //전체
                {
                  value: "0",
                  name:
                    props.lanData.length > 0
                      ? props.lanData.filter(
                          (f) =>
                            f.lanId === "Radio_All" && f.lanType === "RADIO"
                        )[0].lanName
                      : "",
                },
                //거래처
                {
                  value: "1",
                  name:
                    props.lanData.length > 0
                      ? props.lanData.filter(
                          (f) =>
                            f.lanId === "Radio_ItemName" &&
                            f.lanType === "RADIO"
                        )[0].lanName
                      : "",
                },
              ]}
              value={selectedRadio}
              onChange={(e) => {
                setSelectedRadio(e.target.value);
              }}
            />
            <DatePicker
              className={"datepicker-custom-input"}
              style={{ width: "120px", marginRight: "5px" }}
              selected={props.startDate}
              onChange={(e) => {
                props.setStartDate(e);
              }}
            />
            ~
            <DatePicker
              className={"datepicker-custom-input"}
              style={{ width: "120px", marginLeft: "5px" }}
              selected={props.endDate}
              onChange={(e) => {
                props.setEndDate(e);
              }}
            />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <AuthGroupButton
              pageName="ST10020"
              target="G01"
              refreshNone="none"
              selectFunc={() => {
                props.SearchLogic();
              }}
              saveFunc={() => {
                props.SaveConfirm();
              }}
            />
          </div>
        </Card>
        <Section />
        <div
          className="ag-theme-alpine no-scroll"
          style={{ width: "100%", height: "770px" }}
        >
          <AgGridReact
            ref={gridRef}
            animateRows={true}
            columnDefs={columnDefs}
            groupIncludeTotalFooter={true}
            defaultColDef={{
              flex: 1,
              editable: true,
              resizable: true,
              sortable: true,
              filter: true,
              floatingFilter: true,
            }}
            rowData={props.rowData}
            rowSelection="multiple"
            onSelectionChanged={() =>
              GridFunctions.onSelectionChanged(
                gridRef,
                props.setSelectedRowData
              )
            }
            autoGroupColumnDef={{ minWidth: 340, headerName: "품목명" }}
            groupDisplayType={"singleColumn"}
            onCellClicked={onCellClicked}
            // suppressRowClickSelection={true}
            onCellValueChanged={(e) => {
              GridFunctions.onCellValueChanged(
                e,
                gridRef,
                props.setChangedRowData
              );
            }}
            suppressAggFuncInHeader={true}
            enableCellChangeFlash={true}
            getRowStyle={(e) => (e.data ? GridFunctions.getRowStyle(e) : "")}
          />
        </div>
      </div>
    </div>
  );
}

export default ST10020;
